import { baseComponentSchema } from 'ctm-vertical-base';

import header from './header.json';
import footer from './footer.json';
import results from './results.json';
import sidebar from './sidebar.json';
import moreInfo from './more_info.json';
import callOptions from './call_options.json';
import resultsFeatures from './results_features.json';
import resultsQuickPrice from './results_quick_price.json';
import resultsFilters from './results_filters.json';
import noResultsOverlay from './no_results.json';
import pleaseWait from './please_wait.json';
import insurerHandover from './insurer_handover.json';
import content from './content.json';
import campaignEmailNotification from './campaign_email_notification.json';
import optinPrivacy from './optin_privacy.json';
import components from './components.json';

export default {
    ...baseComponentSchema,
    ...header,
    ...footer,
    ...components,
    ...results,
    ...sidebar,
    ...moreInfo,
    ...callOptions,
    ...resultsFeatures,
    ...resultsQuickPrice,
    ...resultsFilters,
    ...noResultsOverlay,
    ...pleaseWait,
    ...insurerHandover,
    ...content,
    ...campaignEmailNotification,
    ...optinPrivacy
};
